import {Component, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {MatchDetailViewService} from '@modules/game-detail/services/match-detail-view.service';
import {LinkService} from '@core/services/link.service';

@Component({
  selector: 'app-match-score-header',
  templateUrl: './match-score-header.component.html',
  styleUrls: ['./match-score-header.component.scss']
})
export class MatchScoreHeaderComponent implements OnInit {

  public homeTeamLink: string;
  public awayTeamLink: string;
  public homeTeamLogo: string;
  public awayTeamLogo: string;

  constructor(@Inject(PLATFORM_ID) protected _platformId: Object,
              public matchDetailViewService: MatchDetailViewService,) { }

  ngOnInit(): void {
    this.homeTeamLink = LinkService.getTeamLink(this.matchDetailViewService.data.homeTeam.readable_id);
    this.awayTeamLink = LinkService.getTeamLink(this.matchDetailViewService.data.awayTeam.readable_id);
    this.homeTeamLogo = this.matchDetailViewService.data.homeTeam.getLogoImageUrl('medium');
    this.awayTeamLogo = this.matchDetailViewService.data.awayTeam.getLogoImageUrl('medium');
  }

  public getScore(): string {
    const scores = this.matchDetailViewService.data?.scores;
    return `${scores.home } : ${ scores.away }`
  }
}
